<template>
  <div
    v-loading="!isLoaded"
    class="container-plan-design"
  >
    <template v-if="isLoaded">
      <template v-if="!error">
        <plan-design-table
          v-for="container in containers"
          :key="container.id"
          :container="container"
        />
      </template>
      <div
        v-else-if="error"
        id="container-error"
      >
        <bp-alert
          :description="error"
          show-icon
          type="error"
        />
      </div>
    </template>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import PlanDesignTable from './Table';

  /**
   * A component used to fetch plan design values for a particular product and update the planDesign store module.
   *
   * @vuedoc
   * @exports PlanDesign
   * @category Components
   */
  export default {
    name: 'PlanDesign',
    components: { PlanDesignTable },
    props: {
      /**
       * The ID of the product used to interact with the store.
       */
      productId: {
        type: [Number, String],
        required: true,
      },
    },
    computed: {
      ...mapState('planDesignAttributes', [
        'error',
        'containers',
        'isLoaded',
      ]),
    },
    watch: {
      productId: {
        /**
         * Trigger store action to load plan design attributes for this product.
         *
         * @param {string | number}newValue
         */
        handler(newValue) {
          this.loadPlanDesignAttributes(newValue);
        },
        immediate: true,
      },
    },
    beforeDestroy() {
      this.resetState();
    },
    methods: {
      ...mapActions('planDesignAttributes', ['resetState', 'loadPlanDesignAttributes']),
    },
  };
</script>

<style lang="scss" scoped>
  .container-plan-design {
    width: 100%;
  }
</style>
